import { StaticImageData } from 'next/image'
import { ImageWithTextRoot, ImageColumn, FlexBox, CopyColumn } from './ImageWithText.styles'
import Image from 'next/image'
import { useTranslation } from 'hooks/useTranslation'
import { TranslationKeys } from 'locales/translationKeys'

type ImageWithTextProps = {
  imageSrc: StaticImageData
  imageAlt: TranslationKeys
  copyColumn: React.ReactNode
  imageSide?: 'left' | 'right'
  isMobileImageBottom?: boolean
}

export const ImageWithText = ({
  imageSrc,
  imageAlt,
  imageSide = 'left',
  isMobileImageBottom = false,
  copyColumn,
}: ImageWithTextProps) => {
  const { t } = useTranslation()
  return (
    <ImageWithTextRoot>
      <FlexBox imageSide={imageSide} isMobileImageBottom={isMobileImageBottom}>
        <ImageColumn className='image-col'>
          <Image src={imageSrc} alt={t(imageAlt)} />
        </ImageColumn>
        <CopyColumn className='copy-col'>{copyColumn}</CopyColumn>
      </FlexBox>
    </ImageWithTextRoot>
  )
}
